const files = document.querySelectorAll("td > a.file");
const loca  = window.location.href;
const icons = {pdf:"fa-file-pdf-o", ppt:"fa-file-powerpoint-o", pptx:"fa-file-powerpoint-o", doc:"fa-file-word-o", docx:"fa-file-word-o", rar: "fa-compress", zip:"fa-compress", xls:"fa fa-file-excel-o", xlsx:"fa fa-file-excel-o", mp4:"fa fa-video-camera", jpg: "fa-file-image-o", jpeg: "fa-file-image-o", gif: "fa-file-image-o", png: "fa-file-image-o"};
const embed = ["jpg"]; //const embed = ["jpg", "jpeg", "gif", "png"];
files.forEach( function(el, index) {
  var tmp = el.title.split(".");
  var ext = el.title.split(".").pop().toLowerCase();
  var icon = icons[ext];

  var url = el.getAttribute('href');
  tmp[tmp.length-1] = "";
  var tmp_title = tmp.join("");

  if(embed.indexOf(ext) > -1) {
    // el.innerHTML = `<i class="fa ` + icon + ` fa-3x text-info"></i>&nbsp; ` + el.innerHTML;

    var newa = document.createElement("a");
    newa.href=url;
    newa.setAttribute("data-lightbox", "image");
    newa.innerHTML = `<div class="clearfix"></div><img src="` + url + `" class="img-fluid" style="width:200px;">`;
    el.parentNode.parentNode.children[2].appendChild(newa);
    el.parentNode.parentNode.children[3].innerHTML = `<i class="fa ` + icon + ` fa-2x text-info"></i>&nbsp; `;
  } else {
    // el.innerHTML = `<i class="fa ` + icon + ` text-info"></i>&nbsp; ` + el.innerHTML;
    el.parentNode.parentNode.children[3].innerHTML = `<i class="fa ` + icon + ` fa-2x text-info"></i>`;
  };

  el.addEventListener("click", function(e) {
    e.preventDefault()

    var anchor = document.createElement("a");
    anchor.href = el.href;
    anchor.download = el.title;
    anchor.click();
  });
});
